import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { legacyJsdReportsRoute } from '@jira/router-routes__legacy-jsd-reports-routes/src/legacyJsdReportsRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyJsdReportsRouteEntry: JiraLegacyRoute<RouteResources> = createLegacyEntry(
	legacyJsdReportsRoute,
	() => ({
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			getConsolidationStateResource(),
		],

		entryPoint: () => pageEntryPoint,
	}),
);
